import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    const pathFrontEnd = '/entitymanagers/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}entitymanagers/delete`,
        endpoint: config.endpoints.backend + 'entitymanagers/getall',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall'
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'pdc_entity_id',
                type: 'select',
                label: 'Entidade',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllEntities,
                    label: 'corporate_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 4
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ],
    }

    let list = {
        labelTitle: 'Lista de Gestores de Entidade',
        labelTitleButtonAdd: 'Incluir novo gestor de entidade',
        fieldsShowOnDelete: ['corporate_name'],
        showPrintButtons: true,
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'name',
                label: 'Nome do Gestor'
            },
            {
                name: 'entity',
                label: 'Entidade'
            },
            {
                name: 'status',
                label: 'Status',
                width: '10%'
            },
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
